function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var convertFormDataToAddress = function convertFormDataToAddress() {
  var _formData$name, _formData$address, _formData$address2, _formData$city, _formData$state, _formData$zip, _formData$country$val, _formData$country;
  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var address = {
    name: (_formData$name = formData.name) !== null && _formData$name !== void 0 ? _formData$name : '',
    address1: (_formData$address = formData.address1) !== null && _formData$address !== void 0 ? _formData$address : '',
    address2: (_formData$address2 = formData.address2) !== null && _formData$address2 !== void 0 ? _formData$address2 : '',
    city: (_formData$city = formData.city) !== null && _formData$city !== void 0 ? _formData$city : '',
    state: (_formData$state = formData.state) !== null && _formData$state !== void 0 ? _formData$state : '',
    zip: (_formData$zip = formData.zip) !== null && _formData$zip !== void 0 ? _formData$zip : ''
  };
  if (Number((_formData$country$val = (_formData$country = formData.country) === null || _formData$country === void 0 ? void 0 : _formData$country.value) !== null && _formData$country$val !== void 0 ? _formData$country$val : 0) !== 0) {
    var _formData$country$lab, _formData$country2;
    address.country = {
      id: Number(formData.country.value),
      name: (_formData$country$lab = (_formData$country2 = formData.country) === null || _formData$country2 === void 0 ? void 0 : _formData$country2.label) !== null && _formData$country$lab !== void 0 ? _formData$country$lab : ''
    };
  }
  return address;
};
export var convertFormDataToFapiaoCreationRequest = function convertFormDataToFapiaoCreationRequest(formData, additionalData) {
  var _formData$serviceType;
  var organization = {
    name: formData.organizationName.value,
    address: formData.organizationAddress || '',
    phoneNumber: formData.organizationPhone || '',
    bankInformation: {
      name: formData.bankInformationName || '',
      accountNumber: formData.bankInformationAccountNumber || ''
    },
    taxpayerNumber: formData.taxpayerNumber
  };
  var fapiao = {
    type: formData.type,
    serviceType: {
      id: formData.serviceType.value,
      name: (_formData$serviceType = formData.serviceType.label) !== null && _formData$serviceType !== void 0 ? _formData$serviceType : ''
    },
    organization: organization,
    contactInformation: {
      email: formData.contactEmail,
      phoneNumber: formData.contactPhone || ''
    },
    paymentId: additionalData.paymentId,
    receiptCode: additionalData.receiptCode,
    shippingAddress: convertFormDataToAddress(formData.shippingAddress)
  };
  return {
    fapiao: fapiao
  };
};
var convertFapiaoOrganization = function convertFapiaoOrganization(organization) {
  return {
    organizationAddress: organization.address,
    organizationName: {
      label: organization.name,
      value: organization.name
    },
    organizationPhone: organization.phoneNumber,
    bankInformationAccountNumber: organization.bankInformation.accountNumber,
    bankInformationName: organization.bankInformation.name,
    taxpayerNumber: organization.taxpayerNumber
  };
};
export var convertFapiaoDetails = function convertFapiaoDetails(fapiao) {
  var shippingAddress = _objectSpread(_objectSpread({
    address1: '',
    address2: '',
    city: '',
    name: '',
    organization: '',
    phone: '',
    state: '',
    zip: ''
  }, fapiao.shippingAddress), {}, {
    country: fapiao.shippingAddress ? {
      value: fapiao.shippingAddress.country.id,
      label: fapiao.shippingAddress.country.name
    } : ''
  });
  return _objectSpread(_objectSpread({
    approved: fapiao.approved
  }, convertFapiaoOrganization(fapiao.organization)), {}, {
    contactEmail: fapiao.contactInformation.email,
    contactPhone: fapiao.contactInformation.phoneNumber,
    failureMessage: fapiao.failureMessage,
    fapiaoId: fapiao.fapiaoId,
    identity: fapiao.identity,
    number: fapiao.number,
    receiptCode: fapiao.receiptCode,
    serviceType: {
      value: fapiao.serviceType.id,
      label: fapiao.serviceType.name
    },
    serviceTypeName: fapiao.serviceType.name,
    shippingAddress: shippingAddress,
    status: fapiao.status,
    type: fapiao.type,
    value: fapiao.identity
  });
};
export var convertFapiaoDisplayDetails = function convertFapiaoDisplayDetails(json) {
  var fapiaos = json.fapiaos.map(function (fapiaoDetails) {
    return convertFapiaoDetails(fapiaoDetails);
  });
  return {
    fapiaos: fapiaos
  };
};
export var convertFapiaoOrganizationRequest = function convertFapiaoOrganizationRequest(json) {
  var organizations = json.results.map(function (organization) {
    return convertFapiaoOrganization(organization);
  });
  return {
    organizations: organizations
  };
};